import { render, staticRenderFns } from "./ChangePicture.vue?vue&type=template&id=06289594&scoped=true"
import script from "./ChangePicture.vue?vue&type=script&lang=js"
export * from "./ChangePicture.vue?vue&type=script&lang=js"
import style0 from "./ChangePicture.vue?vue&type=style&index=0&id=06289594&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06289594",
  null
  
)

export default component.exports